export enum GTM_EVENT {
    ADD_PAYMENT_INFO = 'add_payment_info',
    ADD_SHIPPING_INFO = 'add_shipping_info',
    ADD_TO_CART = 'add_to_cart',
    BEGIN_CHECKOUT = 'begin_checkout',
    VIEW_ITEM_LIST = 'view_item_list',
    PURCHASE = 'purchase',
    REMOVE_FROM_CART = 'remove_from_cart',
    SELECT_ITEM = 'select_item',
    SELECT_PROMOTION = 'select_promotion',
    VIEW_PROMOTION = 'view_promotion',
    VIEW_CART = 'view_cart',
    VIEW_ITEM = 'view_item',
    ADD_COUPON = 'add_coupon',
    REMOVE_COUPON = 'remove_coupon',
    ADD_GIFT_CARD = 'add_gift_card',
    REMOVE_GIFT_CARD = 'remove_gift_card',
    OVERLAY_SEARCH_RESULTS = 'overlay_search_results',
    PRODUCT_RESERVATION_COMPLETE = 'product_reservation_complete',
    CLICK_WISHCLOUD_BUTTON = 'click_oenskesky_button',
    ERROR_WISHCLOUD = 'oenskesky_error_message',
    ADD_REWARD = 'add_reward',
    REMOVE_REWARD = 'remove_reward',
    RESERVE_VOUCHER = 'reserve_voucher',
    RELEASE_VOUCHER = 'release_voucher',
    OPEN_MODAL = 'open_modal',
    SELECT_STORE = 'select_store',
    SWITCH_TOGGLE = 'switch_toggle',
    OPEN_ACCORDION = 'open_accordion',
    SELECT_QUANTITY = 'select_quantity',
    LOCATION_SEARCH = 'location_search',
    USED_STORE_PICKUP_OPTION = 'used_store_pickup_option',
    ALGOLIA_SEARCH = 'algolia_search',
}

export enum StorePickupContext {
    PdpDrawer = 'store_pickup_pdp_drawer',
}

export enum StorePickupOption {
    ClickAndReserve = 'click_and_reserve',
    ClickAndCollect = 'click_and_collect',
}

export type GTMStorePickupDrawerOpenModel = {
    context: StorePickupContext.PdpDrawer;
    option: StorePickupOption.ClickAndReserve;
    availableStoresCr: number;
    availableStoresCc: number;
    totalStores: number;
};

export type GTMStorePickupDrawerSelectModel = {
    context: StorePickupContext.PdpDrawer;
    option: StorePickupOption;
    shopId: string;
};

export type GTMStorePickupDrawerToggleModel = {
    context: StorePickupContext.PdpDrawer;
    option: StorePickupOption.ClickAndReserve;
    mode: 'enabled' | 'disabled';
    availableStoresCr: number;
    availableStoresCc: number;
    totalStores: number;
};

export type GTMStorePickupDrawerAccordionModel = {
    context: StorePickupContext.PdpDrawer;
    option: StorePickupOption.ClickAndReserve;
    shopId: string;
    index: number;
};

export type GTMStorePickupDrawerLocationSearchModel = {
    context: StorePickupContext.PdpDrawer;
    option: StorePickupOption.ClickAndReserve;
} & ({ method: 'geolocation' } | { method: 'manual_input'; inputType: 'zip' | 'city' });

export type GTMUsedStorePickupOptionModel = {
    context: StorePickupOption;
    shopId: string;
};

export type GTMStorePickupDrawerQuantityModel = {
    context: StorePickupContext.PdpDrawer;
    option: StorePickupOption.ClickAndReserve;
    oldQuantity: number;
    newQuantity: number;
    method: 'plus-btn' | 'minus-btn' | 'manual_input';
    availableStoresCr: number;
    availableStoresCc: number;
    totalStores: number;
};

export enum GTM_LIST_ID {
    PRODUCT_LIST = 'ProductList',
    ARTICLE_PRODUCTS = 'ArticleProducts',
    SEARCH_RESULTS = 'SearchResults',
    PRODUCT_CAROUSEL = 'ProductCarousel',
    COMPLEMENTARY_PRODUCTS = 'ComplementaryProducts',
    RAPTOR = 'Raptor',
}

export enum GTM_LIST_NAME {
    ARTICLE_LIST = 'ArticleList',
    COMPLEMENTARY = 'Complementary',
    CAROUSEL = 'Carousel',
    RAPTOR = 'Raptor',
}

export type GTMProductEventModel = {
    index?: number;
    item_brand: string;
    item_category: string;
    item_category2?: string;
    item_category3?: string;
    item_category4?: string;
    item_category5?: string;
    item_color: string;
    item_freight_group: string;
    item_id: string;
    item_name: string;
    price: number;
    item_product_id: string;
    item_rating?: string;
    item_ratingCount?: number;
    item_ratingValue?: number;
    item_serie: string;
    item_variant: string;
    item_warehouse_type: string;
    quantity?: number;
    stockStatus?: boolean;
};

export type GTMBasketItemModel = {
    item: string;
    quantity: string;
    price: string;
    unique_id: string;
};

export type GTMOverlaySearchModel = {
    search_term: string;
    number_of_results?: number;
    search_url: string;
    destination_url?: string;
    type_of_result?:
        | 'Product'
        | 'Search suggestion'
        | 'See all products'
        | 'Popular searches'
        | 'Other shortcuts';
    product_id?: string;
    product_name?: string;
    product_ean?: string;
    product_brand?: string;
    product_full_name?: string;
};

export type GTMAlgoliaSearchModel = {
    index: string;
    indexUsed?: string;
    query: string;
    queryID?: string;
    nbHits: number;
};
